/* eslint-disable indent */
// export const menu = {
// }

export const collections = {
  weather: {
    SUNNY: { icon: 'sunny', color: 'gold' },
    CLOUDY: { icon: 'cloudy', color: 'lightsteelblue' },
    SUNNY_CLOUDY: { icon: 'sunnyCloudy', color: 'dodgerblue' },
    SNOWY: { icon: 'snowy', color: 'deepskyblue' },
    RAINY: { icon: 'rainy', color: 'darkgray' },
  },
  centerTypes: [
    { _id: 'OWNER', value: 'OWNER' },
    { _id: 'FRANCHISE', value: 'FRANCHISE' },
    { _id: 'OTHER', value: 'OTHER' },
  ],
  activityTypes: [
    { _id: 'SERVICES', value: 'SERVICES' },
    { _id: 'WASHES', value: 'WASHES' },
    { _id: 'SERVICES_AND_WASHES', value: 'SERVICES_AND_WASHES' },
  ],
  zones: [
    'Andalucía',
    'Aragón',
    'Asturias',
    'Canarias',
    'Cantabria',
    'Castilla y León',
    'Castilla-La Mancha',
    'Cataluña',
    'Ceuta',
    'Comunidad Valenciana',
    'Comunidad de Madrid',
    'Extremadura',
    'Galicia',
    'Islas Baleares',
    'La Rioja',
    'Melilla',
    'Navarra',
    'País Vasco',
    'Región de Murcia',
  ],
  technics: [
    { _id: 'aspirators', value: 'aspirators' },
    { _id: 'tracks', value: 'tracks' },
    { _id: 'others', value: 'others' },
  ],
}
